import { Currency, ETHER, Token } from '@uniswap/sdk'
import { BTCCurrency } from './index'

export function currencyId(currency: Currency): string {
  if (currency === ETHER) return 'BTC'
  if (currency instanceof Token) return currency.address
  throw new Error('invalid currency')
}
